export default __webpack_public_path__ + "static/media/fMaltoBuza22.10c0489c.png";